export { getRootCommand } from './commands/root-command.js';
